<template>
        <gd-modal name="share-blog-modal" ref="share-blog-modal" :title="$t('frontend_grooveblog_share_blog')">
        <div class="flex flex-col px-8 py-5">
          <div class="flex flex-col w-full mb-4">
            <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_blog_name') }}</label>
            <text-input
              class="custom-input-text"
              v-model="shareBlog.name"
              :validator="$v.shareBlog.name"
              placeholder=""
            />
          </div>
          <div class="flex flex-col w-full mb-4">
            <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_subdomain') }}</label>
            <text-input
              class="custom-input-text"
              v-model="shareBlog.subdomain"
              :validator="$v.shareBlog.subdomain"
              placeholder=""
            />
            <div class="text-grey-500 mt-1">
              {{ shareBlog.subdomain }}.{{grooveblogDomain}}
            </div>
            <div
              class="w-full error text-primary-dark mt-1 text-sm"
              v-if="shareDomainMessage"
            >
              {{ $t('frontend_grooveblog_subdomain_unavailable') }}
            </div>
          </div>
          <div class="flex flex-row w-full justify-center">
            <gd-button
              class="text-center h-10 border-grey-1 mr-4"
              size="large"
              v-on:click="shareCloseModal"
              >{{ $t('frontend_cancel') }}</gd-button
            >
            <gd-button
              class="text-center h-10"
              size="large"
              primary
              v-on:click="createshareBlog"
              >{{ $t('frontend_done') }}</gd-button
            >
          </div>
        </div>
      </gd-modal>
</template>
<script>
import axios from 'axios';
import {
  required,
  minLength,
  maxLength,
  alphaNum,
} from 'vuelidate/lib/validators';
import Loader from '@groovepages/gd-ui-kit/components/Loader';



export default {
  name: 'share',
  middleware: 'auth',
  // layout: 'defaultWithoutSidebar',
  components: {
    Loader,
  },
  data() {
    return {
      loading: true,
      shareDomainMessage:false,
      shareBlog: {
        name: '',
        subdomain: '',
      },
    };
  },
  validations: {
    shareBlog: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(80),
      },
      subdomain: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
        alphaNum,
      },
    },
  },
  computed: {
    grooveblogDomain() {
      return window.gdEnv['VUE_APP_GROOVEBLOG_URL'].match(/\/\/(.+)$/)[1] || 'grooveblog.com'
    }
  },
  mounted() {
    console.log(this.$refs);
    this.$refs['share-blog-modal'].open();
    this.loading = false;
  },
  methods: {
    shareCloseModal(){

    },
     async createshareBlog() {
      this.$v.shareBlog.$touch();
      if (!this.$v.shareBlog.$invalid) {
        this.$v.shareBlog.$reset();
        this.showLoader();
        await axios
          .get(`/blogs/check-subdomain/${  this.shareBlog.subdomain}`)
          .then((response) => {
            this.shareDomainValue = response.data.available;
            this.hideLoader();
          })
          .catch((error) => {
            console.log(error);
          });
        if (this.shareDomainValue) {
          this.showLoader();
          axios
            .post(`/blog/${this.$route.params.id}/share`,this.shareBlog)
            .then((response) => {
              localStorage.setItem('blog-id', response.data.data.id);
              this.$root.$emit('modal-close', 'share-blog-modal');
              this.$router.push({ name: 'home' });
              this.hideLoader();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.shareDomainMessage = true;
        }
      }
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.share-blog-page {
  .fixed.inset-0.w-full.h-full.opacity-50.bg-white {
    opacity: 0.92 !important;
    background-color: grey !important;
  }
}
</style>
